module.exports = __webpack_public_path__ + "static/media/icon_pressure.1b486602.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon_pressure.svg
// module id = 83
// module chunks = 0